import _extends from "@babel/runtime/helpers/extends";
import * as React from 'react';
import { StyledIconBase } from '@styled-icons/styled-icon';
export var Shower = /*#__PURE__*/React.forwardRef(function (props, ref) {
  var attrs = {
    "fill": "currentColor",
    "xmlns": "http://www.w3.org/2000/svg"
  };
  return /*#__PURE__*/React.createElement(StyledIconBase, _extends({
    iconAttrs: attrs,
    iconVerticalAlign: "middle",
    iconViewBox: "0 0 24 24"
  }, props, {
    ref: ref
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 8,
    cy: 17,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 17,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 16,
    cy: 17,
    r: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13 5.08V3h-2v2.08C7.61 5.57 5 8.47 5 12v2h14v-2c0-3.53-2.61-6.43-6-6.92z"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 8,
    cy: 20,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 20,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 16,
    cy: 20,
    r: 1
  }));
});
Shower.displayName = 'Shower';
export var ShowerDimensions = {
  height: 24,
  width: 24
};